var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'content-loader-box': true,
    'content-loader-box--loader-active': _vm.loading
  }},[_c('transition',{attrs:{"name":"fade-fast"}},[(_vm.loading)?_c('app-loader',{class:['content-loader-box__loader', _vm.loaderClass]}):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }